/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectInvitation
 */
export interface ProjectInvitation {
    /**
     * 
     * @type {string}
     * @memberof ProjectInvitation
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInvitation
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInvitation
     */
    email?: string;
}

/**
 * Check if a given object implements the ProjectInvitation interface.
 */
export function instanceOfProjectInvitation(value: object): value is ProjectInvitation {
    return true;
}

export function ProjectInvitationFromJSON(json: any): ProjectInvitation {
    return ProjectInvitationFromJSONTyped(json, false);
}

export function ProjectInvitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInvitation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'token': json['token'] == null ? undefined : json['token'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ProjectInvitationToJSON(json: any): ProjectInvitation {
    return ProjectInvitationToJSONTyped(json, false);
}

export function ProjectInvitationToJSONTyped(value?: ProjectInvitation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'token': value['token'],
        'email': value['email'],
    };
}

